import type { QueryProps } from "shared/react";
import type { PostData } from "shared/schema";
import { formatDate } from "shelving";
import { Grid, MediaImage } from "shared/react";
import { useQuery } from "../util/db.js";

export function PostGrid({ query, ...props }: QueryProps<PostData>): React.ReactElement {
	return (
		<Grid //
			store={useQuery("post", query)}
			mapper={({ id, date, images }) =>
				images[0] ? (
					<a key={id} className="photo" href={`/post/${id}`}>
						<MediaImage path={images[0]} title={`Post on ${formatDate(date)}`} />
					</a>
				) : null
			}
			mods="grid-cols-3 grid-square width-wide"
			{...props}
		/>
	);
}
